<template>
  <el-menu unique-opened background-color="#001529" text-color="#b3b9bf" active-text-color="#fff" mode="vertical">
    <SidebarItem :menus="menu" />
  </el-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
export default {
  name: 'sidebar',
  components: {
    SidebarItem
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'menu'
    ])
  },
  created() {
    this.getMenu({ userId: this.currentUser.id })
  },
  methods: {
    ...mapActions([
      'getMenu',
      'getCurrentUser'
    ])
  }
}
</script>

<style lang="scss">
.el-icon-arrow-down {
  font-size: 16px;
}

.el-menu {
  border-right: none;
}

.el-aside {
  background-color: #001529;
  min-height: 720px;
  border-right: 1px solid #e6e6e6;

  &[collapse="true"] {
    width: auto !important;
  }
}

.el-menu--inline {
  background-color: #000c17 !important;

  .el-menu-item {
    background-color: #000c17 !important;
  }

  .el-submenu__title {
    background-color: #000c17 !important;
  }
}

.el-menu-item.is-active {
  background-color: #2d8cf0 !important;
}
</style>
